import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import LandingCafeCover from './LandingCafeCover';
import LandingNoteCover from './LandingNoteCover';
import Slide from '@mui/material/Slide';

const CoverContainer = styled('div')(({ theme }) => ({
  backgroundColor: '#633F31',
  display: 'flex',
  alignItems: 'center',
  position: 'fixed',
  right: '0',
  top: '0',
  width: '50%',
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

const CloseBtn = styled(IconButton)({
  right: '30px',
  top: '27px',
  position: 'absolute',
  padding: '0',
  zIndex: '1',
  color: '#fff',
});

const ContentContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  color: '#fff',
  padding: '0 4vw',
  '& >*': {
    width: '100%',
  },
});

const LandingCover = ({ closeCover, cover }) => {
  return (
    <Slide direction="left" in={cover ? true : false} mountOnEnter unmountOnExit>
      <CoverContainer cover={cover}>
        <CloseBtn aria-label="close" onClick={closeCover}>
          <CloseIcon />
        </CloseBtn>
        <ContentContainer>
          {cover === 'cafe' && <LandingCafeCover />}
          {cover === 'note' && <LandingNoteCover />}
        </ContentContainer>
      </CoverContainer>
    </Slide>
  );
};
export default LandingCover;
